import {EntityMananger} from './core.entity.mananger';

export function PrimaryKey(): PropertyDecorator {
    return (target: any, key: string) => {
        const metadata = EntityMananger.getEntityColumn(target.constructor.name, key);

        metadata.isPrimaryKey = true;

        EntityMananger.registerEntityColumns(target.constructor.name, metadata);
    };
}
